import type { ReactNode } from 'react'

import { QueryClientProvider } from '@tanstack/react-query'

import { queryClient } from '~/shared/api'

type QueryProviderProps = {
  children: ReactNode
}

/** Единственный singleton QueryClient на приложение (docs/data-layer.md §2). */
export function QueryProvider(props: QueryProviderProps) {
  const { children } = props
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
